import Input, { Textarea } from './Input';

export default Input;
export { Input, Textarea };

